import cn from "classnames";
import React from "react";

import SmallLoader from "components/SmallLoader/SmallLoader";
import styles from "./icon-button.module.scss";

interface IconButtonInterface {
  icon: any;
  className?: string;
  alt: string;
  disabled?: Boolean;
  type?: "button" | "submit" | "reset";
  onClick?: (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.KeyboardEvent<HTMLButtonElement>
  ) => void;
  isLoading?: boolean;
}

const IconButton = ({
  icon,
  type,
  className,
  alt,
  disabled,
  onClick,
  isLoading
}: IconButtonInterface): JSX.Element => {
  return (
    <button
      className={cn(styles["icon-button"], className, {
        [styles["icon-button--disabled"]]: disabled
      })}
      onClick={!disabled ? onClick : () => {}}
      type={type || "button"}
    >
      {isLoading ? (
        <SmallLoader type="DARK" />
      ) : typeof icon === "string" ? (
        <img src={icon} alt={alt} className={styles["icon-button__icon"]} />
      ) : (
        icon
      )}
    </button>
  );
};

export default IconButton;
